import { callApiWithToken } from "../utils/http_common";
import { callApi } from "../utils/http_common";

const getCountryByIp = (ip) => {
  return callApiWithToken.get(`/common/getUserCountry?ip=${ip}`);
};

const getCountriesList = () => {
  return callApi.get("/common/countries");
};
const getCountries = () => {
  return callApi.get("/common/getCountries");
};
const CommonService = {
  getCountryByIp,
  getCountriesList,
  getCountries,
};

export default CommonService;
